import React from "react";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";

interface NavItemProps {
  dataTestId: string;
  displayName: any;
  listRef: React.RefObject<HTMLLIElement>;
  activeTab: any;
  it: {
    id: string | number;
    displayName: string;
    icon?: (color: string) => JSX.Element;
  };
  handleOnTabClick: any;
  showIcon?: boolean;
  removeIcon?: boolean;
  className?: any;
}

const NavItem: React.FC<NavItemProps> = ({
  dataTestId,
  listRef,
  activeTab,
  it,
  handleOnTabClick,
  showIcon = true,
  removeIcon = false,
  className,
  displayName,
}) => {
  const { t } = useTranslationHook();
  return (
    <li
      data-testid={`${dataTestId}-navbar`}
      ref={listRef}
      className={className}
      key={it?.id}
      role="none"
      onClick={() => handleOnTabClick(it?.id, it?.displayName)}
    >
      {showIcon && !removeIcon && !!it?.icon && it.icon(activeTab ? "#fff" : "#000")}
      {t(displayName)}
    </li>
  );
};
export default wrapperHOC(NavItem, {
  componentName: "NavItem-SectionNavigation-Global",
  showForChina: true,
});
